import { useState } from "react";

// The eye from the design: an ellipse and a pupil, with a slash while the
// password is showing.
function EyeIcon({ off }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <ellipse cx="12" cy="12" rx="9" ry="6" />
      <circle cx="12" cy="12" r="2.5" />
      {off && <line x1="4" y1="20" x2="20" y2="4" />}
    </svg>
  );
}

/**
 * A password field with an eye button. Each field keeps its own show/hide
 * state, so "Ulangi password" has a toggle of its own.
 *
 * Takes any <input> prop. `variant="login"` is the navy login panel; the
 * default fits the rest of the app, where the caller supplies the field's
 * classes (usually "glass-input") and only the right padding for the eye is
 * added here.
 */
export default function PasswordInput({ variant = "app", className = "", ...inputProps }) {
  const [show, setShow] = useState(false);
  const login = variant === "login";
  const label = show ? "Sembunyikan password" : "Tampilkan password";

  return (
    <div className={login ? "login-pw" : "relative"}>
      <input
        {...inputProps}
        type={show ? "text" : "password"}
        className={login ? `login-input login-input-pw ${className}`.trim() : `${className} pr-11`.trim()}
      />
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        aria-label={label}
        aria-pressed={show}
        title={label}
        className={
          login
            ? "login-pw-toggle"
            : "absolute right-1.5 top-1/2 -translate-y-1/2 w-8 h-8 inline-flex items-center justify-center rounded-md text-muted hover:text-strong transition-colors"
        }
      >
        <EyeIcon off={show} />
      </button>
    </div>
  );
}
